<template>
	<div class="stages-text fontFam" v-if="stages&&stages.length" :style="{ maxWidth: getWidth }">
		<!-- <Vue3Lottie class="loadingAnimate" :animationData="toJSON" :height="55" :width="55"  /> -->
		<!-- 第一层 -->
		<w-collapse
			:style="{ maxWidth: getWidth }"
			v-if="getLastData &&!getLastData.isKbCollapse && (getLastData.visible != false || getLastData.type != 'smart') && (getLastData.type != 'smart' || (getLastData.type == 'smart' && getLastData.keywords && getLastData.keywords.length))"
			class="collpaseBox"
			:class="{isAisearch:props.messageAgent}"
			@change="changeCollapse"
		>
			<w-collapse-item key="1" :class="{headTitle:isMobile}">
				<template #header>
					<div class="total-box" v-if="!props.messageAgent" :class="{mobileBox:isMobile}">
						<SvgIcon class="loadIcon" :name="getLoadingName()" size="16" v-if="loading || loading&&getLastData.status == 'process'"/>
						<SvgIcon  size="16"  class="icon" v-if="!loading && getLastData.status == 'finish'" :name="getResulticon()"  color="var(--search-icon-color)" />
						<CoolJiazaishibai size="16" v-if="!loading && getLastData.status == 'error'" class="icon" />
						<span class="plugin fontFamWeight" v-if="getLastData?.pluginDisplay && getLastData.visible != false && (getLastData.pluginKey == 'YAYI'||getLastData.pluginKey=='CHINESE_MEDICINE')">{{getRoleName()}}</span>
						<span class="plugin fontFamWeight" v-else-if="getLastData?.pluginDisplay && getLastData.visible != false ">{{getLastData.pluginDisplay }}</span>
						<span class="titleTal" v-html="getLastData.title"></span>
						&nbsp;
						<stageIcon v-if="getLastData.type === 'text'&&props.messageAgent && searchEngineType != 0"   :dataList="searchEngineList"></stageIcon>
						<SvgIcon class="arricon" :name="`cool-${parentBox.length ? 'ArrowUpSLineWe' : 'ArrowDownSLineWe'}`" size="14" color="#646479" />
					</div>
					<div class="total-box aisearchBox" v-else :class="{mobileBox:isMobile}">
						<SvgIcon class="loadIcon" :name="getLoadingName()" size="16" v-if="loading || loading&&getLastData.status == 'process'"/>
						<CoolAIshengcheng size="20" v-if="!loading && getLastData.status == 'finish'" class="icon" color="var(--active-color)"/>
						<span class="titleTal">{{t('chat.center.resultTotal')  }}</span>
						&nbsp;
						<stageIcon v-if="getLastData.type === 'text'&&props.messageAgent && searchEngineType != 0"   :dataList="searchEngineList"></stageIcon>
						<SvgIcon class="arricon" :name="`cool-${parentBox.length ? 'ArrowUpSLineWe' : 'ArrowDownSLineWe'}`" size="14" color="#646479" />
					</div>
				</template>
				<div v-show="JSON.stringify(smartKeywords) != '{}'&&!props.messageAgent" class="smart-box" :class="{mobileSmartBox:isMobile}">
					<div class="top" @click="changeSmartCollapse(smartKeywords.isCollspase)">
						<img class="icon icon-img"  v-if="currentRole?.icon||roleIcon" :src="imageUrl(currentRole?.icon)" alt="" />
						<span class="plugin fontFamWeight" v-if="smartKeywords.pluginDisplay && smartKeywords.visible != false  && (smartKeywords.pluginKey == 'YAYI'||smartKeywords.pluginKey=='CHINESE_MEDICINE')">{{ getRoleName() }}</span>
						<span class="plugin fontFamWeight" v-else-if="smartKeywords.pluginDisplay && smartKeywords.visible != false">{{ smartKeywords.pluginDisplay }}</span>
						<span class="title" v-html="smartKeywords.title"></span>
						<SvgIcon
							class="arricon"
							:name="`cool-${smartKeywords.isCollspase == 2 ? 'ArrowUpSLineWe' : 'ArrowDownSLineWe'}`"
							size="14"
							color="#646479"
						/>
					</div>
					<div class="bottom" v-if="smartKeywords.isCollspase == 2">
						<div v-for="(item, index) in smartKeywords.keywords" :key="index" class="keyword">{{ item }}</div>
					</div>
				</div>
				<!-- chat搜索过程 -->
				<!-- <div v-if="resultLists && resultLists.length&&!props.messageAgent" v-for="(item, key) in resultLists" :key="key"> -->
				<div v-if="resultLists && resultLists.length" v-for="(item, key) in resultLists" :key="key">
						<w-collapse
						v-if="(item.status == 'finish' && item.content) || (item.list && item.list.length)"
						class="collapseChildBox"
						@change="changeChildCollapse(item)"
						v-model:active-key="activeKeys"
					>
						<w-collapse-item :key="key + '.1'" :class="{ fiststChild: key == 0 }">
							<template #header>
								<div v-if="item.content || (item.list && item.list.length)" class="child-title">
									<SvgIcon class="icon" :name="getIconUrl(item.pluginIcon)" color="var(--search-icon-color)"/>
									
									<span class="plugin fontFamWeight">{{ item.pluginDisplay }}</span>
									<span class="title" v-html="item.title" :class="{mobileTitle:isMobile}"></span>
									<SvgIcon
										class="arricon"
										:name="`cool-${item.isCollspase == 2 ? 'ArrowUpSLineWe' : 'ArrowDownSLineWe'}`"
										size="14"
										color="#646479"
									/>
								</div>
							</template>
							<div v-if="item.content" class="child-content">{{ item.content }}</div>
							<div v-if="item.list" class="list-box" :style="{ maxWidth: !isMobile?getWidth:'' }">
								<div v-for="(itm, k) in item.list" :key="k" class="box-item" @click="handlerClick(itm)">
									<span class="number">{{ itm.id }}</span>
									<SvgIcon size="14" class="icon" v-if="itm.type == 'KB'" :name="getIconUrl(itm.dataType)" color="#646479" />
									<img @dragstart="preventImageDrag"  class="icon" :src="itm.icon" alt="" v-else-if="itm.type != 'KB' && itm.icon" />
									<CoolFujianA97412md class="icon" size="14" v-else-if="itm.type != 'KB' && !itm.icon" color="#646479"></CoolFujianA97412md>
									<span class="title" v-html="itm.title" :class="[isMobile?'mobileTitle':'pcTitle']"></span>
									<span class="source" v-if="itm.source&&!isMobile">{{ itm.source }}</span>
									<span class="time" v-if="itm.createTime&&!isMobile">[{{ itm.createTime }}]</span>
								</div>
							</div>
						</w-collapse-item>
					</w-collapse>
					<div v-else class="processChildBox" :class="{ mobileProcessBox: isMobile }">
						<div class="process-box" :class="{ lastBox: item.pluginIcon == 'offline' }" v-if="item.type!='smart' && item.visible != false">
							<SvgIcon class="loadIcon" :name="getLoadingName()" size="16" v-if="(item.status == 'process' || item.status == 'init') && item.pluginDisplay"/>
							<SvgIcon
								size="14"
								v-else-if="(item.status == 'finish' || item.status == 'error') && item.pluginDisplay && !fileIcon.includes(item.pluginIcon)"
								class="icon"
								:name="getIconUrl(item.pluginIcon)"
								color="var(--search-icon-color)"
							/>
							<img class="icon icon-img"  v-else-if="(item.status == 'finish' || item.status == 'error') && item.pluginDisplay" :src="imageUrl(currentRole?.icon)" alt="" />
							<span class="plugin fontFamWeight" v-if="item.pluginDisplay  && (item.pluginKey == 'YAYI'||item.pluginKey=='CHINESE_MEDICINE')">{{  getRoleName()}}</span>
							<span class="plugin fontFamWeight" v-else-if="item.pluginDisplay">{{ item.pluginDisplay }}</span>
							<span class="title" :class="{mobileTitle:isMobile}" v-if="item.pluginDisplay" v-html="item.title"></span>
						</div>
					</div>
				</div>
				<!-- ai搜索过程直接展示来源 -->
				<!-- <div class="ai-serachOrigin" :style="{ maxWidth: !isMobile?getWidth:'' }">
					<div v-if="aiSearchResult && aiSearchResult.length&&props.messageAgent" v-for="(item, key) in aiSearchResult" :key="key" @click="handlerClick(item)"> 
						<div v-if="item.status == 'finish'">
							<div v-if="item.type=='text'&&item.content" class="child-content">{{ item.content }}</div>
							<div v-if="item.type=='list'" class="box-item">
									<span class="number">{{ item.id }}</span>
									<SvgIcon size="14" class="icon" v-if="item.type == 'KB'" :name="getIconUrl(item.dataType)" color="#646479" />
									<img @dragstart="preventImageDrag"  class="icon" :src="item.icon" alt="" v-else-if="item.type != 'KB' && item.icon" />
									<CoolFujianA97412md class="icon" size="14" v-else-if="item.type != 'KB' && !item.icon" color="#646479"></CoolFujianA97412md>
									<span class="title" v-html="item.title" :class="[isMobile?'mobileTitle':'pcTitle']"></span>
									<span class="source" v-if="item.source&&!isMobile">{{ item.source }}</span>
									<span class="time" v-if="item.createTime&&!isMobile">[{{ item.createTime }}]</span>
						
							</div>
					</div>
				</div>
				</div> -->
			</w-collapse-item>
		</w-collapse>
		<!-- 思考中不允许展开 -->
		<div
			:style="{ width: getWidth }"
			v-else-if="(getLastData && getLastData.type == 'smart' && getLastData.visible != false && (!getLastData.keywords || !getLastData.keywords.length))||getLastData&&getLastData.isKbCollapse"
			class="loading-box"
		>
			<CoolJiazaishibai size="16" v-if="getLastData.status == 'error'" class="icon" />
			<SvgIcon :name="getLoadingName()" size="16" class="loadIcon" v-else/>
			<span class="plugin fontFamWeight" v-if="getLastData?.pluginDisplay && (getLastData.pluginKey == 'YAYI'||getLastData.pluginKey=='CHINESE_MEDICINE')">{{getRoleName()}}</span>
			<span class="plugin fontFamWeight" v-else-if="getLastData?.pluginDisplay">{{ getLastData.pluginDisplay }}</span>
			<span class="titleTal fontFam" v-html="getLastData.title"></span>
		</div>
		<!-- <template v-else-if="text?.length === 0">{{ t('chat.center.deepthinkIng1') }}9999</template> -->
		<template v-else-if="text?.length === 0">
			<i class="loading-Yeicon"></i>
		</template>
	</div>
</template>
<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted, nextTick, h, watch, defineCustomElement, onBeforeUnmount } from 'vue';
import mittBus from '/@common/utils/mitt';
import { useChatStore } from '/@/stores/chat';
import { useRoute } from 'vue-router';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import stageIcon from '/@common/components/yy-message/components/stageSteps/stageIcon.vue';
import loadingSvg from '/@common/assets/chat/loading.svg';
import { cloneDeep } from 'lodash-es';
import axios from 'axios';
import toJSON from '/@common/assets/json/loading.json';
import DSBridge from '/@common/utils/dsBridge/dsBridge';
const { isMobile } = useBasicLayout();
const fileIcon=ref(['chinese-medicine','offline'])
const route = useRoute();
const resultTilte = ref('');
const parentBox = ref([]);
const hideIcon = ref(true);
const activeKey = ref(1);
const childActive = ref([]);
const stagesIdList = ref([]);
const childCollapseIndex = ref([]);
const resultLists=ref([])
const aiSearchResult=ref([])
const getNewTime = computed(() => {
	return 3;
});
const activeKeys = ref([]);
const smartKeywords = ref({});
import { useI18n } from 'vue-i18n';
interface Props {
	text?: string;
	stages?: [];
	source?: string;
	loading?: boolean;
	width?: number;
	modelVersion?: string;
	answerFinish?: boolean;
	from?:string
	messageAgent?: string
	searchEngineList?: [];
	searchEngineType?: number;
	roleName?:string
	roleIcon?:string
}

const props = defineProps<Props>();
const chatStore = useChatStore();
const { t } = useI18n();
const contentMess = ref({});
const changeSmartCollapse = (val: number) => {
	smartKeywords.value.isCollspase = val == 1 ? 2 : 1;
};
const preventImageDrag = (event) => {
  event.preventDefault(); // 阻止默认行为
};
const getRoleName=()=>{
	if(props.from=='debug'||props.from=='share'){
		return props?.roleName
	}else{
		return props?.messageAgent?t('chat.role.serach'):currentRole.value?.roleName
	}
}
const getResulticon=()=>{
	return localStorage.getItem('winbox-theme')?'cool-jiazaiwancheng-fo1mnkjp': 'cool-jiazaiwancheng'
}
const getLoadingName=()=>{
	return localStorage.getItem('winbox-theme')?'cool-jiazai-hong': 'cool-jiazai2'

}
const changeCollapse = (val) => {
	parentBox.value = val;
	if (val.length && props.answerFinish) {
		//点击展开默认里面的子项展开
		stagesIdList.value=[]
		if (JSON.stringify(smartKeywords.value) != '{}') {
			smartKeywords.value.isCollspase = 2;
		}
		resultLists.value.forEach((item) => {
			item.isCollspase = 2;
		});
		activeKeys.value = childCollapseIndex.value;
	}
};
const handlerClick = (val: object) => {
	if (DSBridge.isDSBridgeEnvironment()) {
		DSBridge.callNative('triggerStages', val)
		return 
	}
	if(val.dataType=='txt'){
		downloadFile(val.url,val.title)
		return
	}else{
		if (val.url) {
		window.open(val.url, '_blank');
	}
	}
	
};
const downloadFile =  (url:string,name:string) => {
	axios.get(url, {responseType: 'blob'}).then((response) => {
		const blob = new Blob([response.data], { type: 'application/;charset=utf-8' })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download =name
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
	})
};
const changeChildCollapse = (val: object) => {
	val.isCollspase = val.isCollspase == 1 ? 2 : 1;
};
const getWidth = computed(() => {
	if (isMobile.value) {
		return 'calc(100vw - 70px)';
	}else if(props.from=='debug'){
		return '100%'
	}
	 else {
		if (props.messageAgent == 'search') {
			return '750px'
		}
		return props.from ? `${props.width}px` : `${chatStore.centerMaxWidth - 154}px`;
	}
});
const getIconUrl = (icon: string) => {
	let obj = {
		hefengtianqi: 'cool-tianqi-f52jp5ep',
		Bing: 'cool-lianwang',
		KB: 'cool-zhishiku-dhmm5104',
		pdf: 'cool-pdf',
		offline: 'cool-yayi-e3c3im8d',
		wenhai: 'cool-zhutiredianfenxiF52jp5c4',
		doc: 'cool-docx',
		docx: 'cool-docx',
		txt: 'cool-txt',
		md: 'cool-markdown',
		'yayi-math': 'cool-shuxuefenxi-f52jp5g0',
		'long_text': 'cool-changwen',
	};
	return obj[icon];
};
const getLastData = computed(() => {
	if (props.stages && props.stages.length) {
		return props.stages[props.stages.length - 1];
	} else {
		return null;
	}
});
const updateAndRemoveDuplicates=(array)=> {
  const map = new Map();
  const newArray = [];
  for (const item of array) {
		item.isCollspase = item.isCollspase || 1
    if (map.has(item.stageId)) {
			if(item.pluginKey=='KB'&&item.status=='process'&&!item.list.length){
				item.isKbCollapse=true
			}else{
				item.isKbCollapse=false
			}
      newArray[map.get(item.stageId)] = item;
    } else {
			if(item.pluginKey=='KB'&&item.status=='process'&&!item.list.length){
				item.isKbCollapse=true
			}else{
				item.isKbCollapse=false
			}
      newArray.push(item);
      map.set(item.stageId, newArray.length - 1);
    }
  }
  return newArray;
}
watch(()=>props.stages,(newVal)=>{
	childCollapseIndex.value = [];
	if(newVal && newVal.length) {
		let resultData=updateAndRemoveDuplicates(newVal)
		let find = resultData.filter((item) => {
			return item.type == 'smart' && item.keywords.length;
		});
		if (find.length) {
			smartKeywords.value = cloneDeep(find[0]);
			smartKeywords.value.isCollspase = 2;
		} else {
			smartKeywords.value = {};
		}
		let data = resultData.filter((item) => item.pluginDisplay);
		data.forEach((item, index) => {
			if (item.content || (item.list && item.list.length)) {
				let str = `${index}.1`;
				childCollapseIndex.value.push(str);
			}
		});
		let aiData=cloneDeep(data)
		resultLists.value=aiData
		//组装ai搜索的结果排序从小到大
		let itemLists=[] as any
		if(aiData.length){
			aiData.forEach(item=>{
				if(item.content){
					itemLists.push({
						...item,
						type:'text',
					})
				}
				if(item.list&& item.list.length){
					if(item.list.length){
						item.list.forEach(itm=>{
						itemLists.push({
						...itm,
						type:'list',
					})
					})
					}
				}
			})
		}
		aiSearchResult.value=itemLists.sort((a:any,b:any)=>a.id-b.id)
	}else{
		resultLists.value=[]
		aiSearchResult.value=[]
	}
}, { deep: true, immediate: true })
const mergeListTypes = (data: any) => {
	let result: any = {};

	try {
		data.forEach((item: any) => {
			const { type, list } = item;
			if (!result[type]) {
				result[type] = [];
			}
			if (list) {
				result[type] = result[type].concat(list);
			}
		});
	} catch (error) {}

	return result['list'] || [];
};
import { useRoleConfig } from '/@/stores/role';
const roleConfig = useRoleConfig();
const currentRole = computed(() => {
	return roleConfig.currentRoleInformation
}
)
const imageUrl = (value: string) => {
	let icon=value?value:'search'
	if((props.from=='debug'||props.from=='share')&&props?.roleIcon){
		icon=props?.roleIcon
	}
	if(props.messageAgent){
		icon='search'
	}
	if(icon=='xiaoya'){
		icon= localStorage.getItem('winbox-theme')?'xiaoyanewYear': 'xiaoya'
	}
	
	return  `${location.origin}/chat/cdn/roleSvg/${icon}.svg`;
};
// const getResultLists = computed(() => {
// 	console.log(888888000,"kkk")
// 	  childCollapseIndex.value = [];
// 	if(props.stages && props.stages.length) {
// 		let resultData=updateAndRemoveDuplicates(props.stages)
// 		let find = resultData.filter((item) => {
// 			return item.type == 'smart' && item.keywords.length;
// 		});
// 		if (find.length) {
// 			smartKeywords.value = cloneDeep(find[0]);
// 			smartKeywords.value.isCollspase = 2;
// 		} else {
// 			smartKeywords.value = {};
// 		}
// 		let data = resultData.filter((item) => item.pluginDisplay&&item.pluginDisplay);
// 		data.forEach((item, index) => {
// 			if (item.content || (item.list && item.list.length)) {
// 				let str = `${index}.1`;
// 				childCollapseIndex.value.push(str);
// 			}
// 		});
// 		resultLists.value=data
// 		return data;
// 	} else {
// 		resultLists.value=null
// 		return null;
// 	}
// });
onMounted(() => {
	stagesIdList.value = [];
});

// 页面卸载时
onUnmounted(() => {});
defineExpose({});
</script>
<style lang="scss" scoped>
@mixin text() {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
@keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
.stages-text {
	// max-width:700px;
	margin-bottom: 5px;
	.loadIcon{
		display: flex;
		align-items: center;
		justify-content: center;
		transform-origin: center center;
        animation: rotate 1s linear infinite;
        will-change: transform;
		margin-right: 3px;
	}
	.collpaseBox {
		// background: #f4f6f9;
		border-radius: 8px;
		border: none;
		display: flex;
		align-self: center;
		width: fit-content;
		.arricon {
			margin-left: 8px;
		}
		:deep(.w-collapse-item-header) {
			width:100%;
			height: 32px;
			border: none;
		    background: var(--stages-bg);

		}
		.headTitle{
			:deep(.w-collapse-item-header-title) {
				width:100% !important;
			}
		}
		.w-collapse-item {
			max-width:100%;
			// width:100%;
			cursor: pointer;
			.w-collapse-item-icon-hover {
				display: none;
			}
		}
		:deep(.w-collapse-item-icon-hover) {
			display: none;
		}
		:deep(.w-collapse-item-header-title) {
			width: 100%;
			// display: inline-block;
		}
		.w-collapse-item-header-title {
			font-size: var(--font14);
			.icon {
				margin-right: 3px;
			}
		}
		:deep(.w-collapse-item-header-left) {
			padding-left: 0px;
		}
		.w-collapse-item-header-right {
			padding-left: 8px;
		}
		:deep(.w-collapse-item-content-box) {
			padding: 0;
		}
		:deep(.w-collapse-item-content) {
			background-color: var(--stages-bg);
			padding: 0px  20px;
		}
		.w-icon-hover:hover::before {
			background-color: transparent;
		}
		.total-box {
			display: flex;
			align-items: center;
			width:100%;
			padding-left:9px;
			.plugin {
				font-weight: 500;
				color: #181b49;
				margin-right: 8px;
				width:fit-content;
				white-space: nowrap;
			}
			.titleTal {
				// max-width:800px;
				flex:1;
				font-size: var(--font16);
				color: #181b49;
				@include text;
			}
			.plugin{
				font-size: var(--font16);
			}
			:deep(.keywords-text) {
				color: #646479;
			}
		}
		.aisearchBox{
			background: var(--stages-bg);
			border-radius: 8px;
			padding: 0 8px;
			// height: 34px;
		}
		.mobileBox{

		}
		.collapseChildBox {
			border: none;
			.fiststChild {
				margin-top: 5px;
			}
			:deep(.w-collapse-item-header) {
				background-color: transparent !important;
				padding-left: 0 !important;
				height: 28px;
			}
			:deep(.w-collapse-item-content) {
			margin: 0;
			padding:0 ;
			
		}
			.child-title {
				display: flex;
				align-items: center;
				.icon {
					margin-right: 3px;
				}
				.plugin {
					font-weight: 500;
					color: #181b49;
					margin-right: 8px;
					white-space: nowrap;
				}
				.title {
					color: #181b49;
					@include text;
					:deep(.keywords-text) {
						color: #646479;
					}
				}
				.mobileTitle{
					// max-width:160px;
					max-width: 90%;
				}
			}
			.child-content {
				font-size: var(--font12);
				color: #181b49;
				line-height: 24px;
			}
			.list-box {
				// margin-left: -20px;
				.box-item {
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					// margin-bottom: 15px;
					// font-weight: 400;
					// font-family: MiSansMedium;
					// background-color: red;
					&:first-child {
						margin-top: 5px;
					}
					.number {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 14px;
						height: 14px;
						background: #e4e8ee;
						font-size: 10px;
						color: #181b49;
						border-radius: 50%;
					}
					img {
						width: 14px;
						height: 14px;
					}
					.icon {
						margin: 0 3px 0 5px;
					}
					.title {
						font-size: 12px;
						color: #181b49;
						@include text;
						font-weight: 400;
						border-bottom:1px solid transparent;
						&:hover{
							// border-bottom:1px solid #181b49;
						}
					}
					.pcTitle{
						max-width:calc(100% - 185px);
					}
					.mobileTitle{
						// max-width:250px;
						max-width: 90%
					}
					.source {
						display: flex;
						align-items: center;
						padding: 0 6px;
						height: 20px;
						border-radius: 4px;
						border: 1px solid #d0d5dc;
						font-size: 11px;
						color: #727298;
						margin-left: 8px;
						@include text;
					}
					.time {
						@include text;
						margin-left: 8px;
						font-size: 12px;
						color: #727298;
						// margin-top: 3px;
					}
					&:last-child {
						margin-bottom: 0;
					}
					&:hover .title{
						border-bottom:1px solid #181b49;
						
					}
				}
			}
			:deep(.w-collapse-item-header-title){
				width:100%;
			}
		}
		.processChildBox {
			.process-box {
				display: flex;
				align-items: center;
				// height: 24px;
				height: 28px;
				.icon {
					margin-right: 3px;
				}
				.plugin {
					font-weight: 500;
					color: #181b49;
					margin-right: 8px;
					white-space: nowrap
				}
				.title {
					color: #181b49;
					@include text;
				}
				.mobileTitle{
					max-width:55%;
				}
				.time {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 24px;
					height: 20px;
					border-radius: 8px;
					border: 1px solid #d0d5dc;
					font-size: 12px;
					color: #646479;
					margin-right: 5px;
				}
			}
			.lastBox {
				line-height: 32px;
				height: 32px;
			}
		}
	}
	.w-collapse-item-active{
		.aisearchBox{
			background-color: transparent;
		}
	}
	.isAisearch{
		width: 100% !important;
		:deep(.w-collapse-item){
		}
		:deep(.w-collapse-item-active){
			width: 100%;
		}
		:deep(.w-collapse-item-header){
			border-radius: 8px;

		}
	}
	.loading-box {
		height: 26px;
		// background: #f4f6f9;
		min-width: 150px;
		margin-right: 10px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 8px 0 0;
		font-size: 14px;
		color: #181b49;
		.plugin {
				font-weight: 500;
				color: #181b49;
				margin-right: 8px;
				width:fit-content;
				font-size: var(--font16);
				white-space: nowrap
			}
		.titleTal{
			// max-width:800px;
				flex:1;
				font-size: var(--font16);
				color: #181b49;
				@include text;
		}
	
		img {
			width: 16px;
			height: 16px;
			margin-right: 3px;
		}
		.icon {
			margin-right: 3px;
		}
	}
}
.icon-img{
	width: 14px;
	height: 14px;
	border-radius: 50%;
}
.smart-box {
	padding: 10px 0 5px;
	.top {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		.icon {
			margin-right: 3px;
		}
		
		.plugin {
			font-weight: 500;
			color: #181b49;
			margin-right: 8px;
			white-space: nowrap
		}
		.title {
			color: #181b49;
			max-width: calc(100% - 80px);
			@include text;
		}
	}
	.bottom {
		display: flex;
		// margin-left: 18px;
		margin-top: 10px;
		flex-wrap: wrap;
		
	}
	.keyword {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		padding: 2px 10px;
		border-radius: 20px;
		font-size: 12px;
		color: #727298;
		// border: 1px solid #d0d5dc;
		margin-right: 5px;
		margin-bottom: 4px;
		background: rgb(236, 238, 240);
	}
}
.ai-serachOrigin{
	padding:10px 16px 0px;
	margin-left: -20px;
	.child-content {
				font-size: var(--font12);
				color: #181b49;
				line-height: 24px;
			}
				.box-item {
					display: flex;
					align-items: center;
					margin-bottom: 8px;
					&:first-child {
						// margin-top: 6px;
					}
					.number {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 14px;
						height: 14px;
						background: #e4e8ee;
						font-size: 10px;
						color: #181b49;
						border-radius: 50%;
					}
					img {
						width: 14px;
						height: 14px;
					}
					.icon {
						margin: 0 7px 0 8px;
					}
					.title {
						font-size: 12px;
						color: #181b49;
						@include text;
						font-weight: 400;
						border-bottom:1px solid transparent;
						&:hover{
							// border-bottom:1px solid #181b49;
						}
					}
					.pcTitle{
						max-width:calc(100% - 300px);
					}
					.mobileTitle{
						// max-width:250px;
						max-width:90%;
					}
					.source {
						display: flex;
						align-items: center;
						padding: 0 6px;
						height: 20px;
						border-radius: 4px;
						border: 1px solid #d0d5dc;
						font-size: 11px;
						color: #727298;
						margin-left: 8px;
						@include text;
					}
					.time {
						@include text;
						margin-left: 8px;
						font-size: 12px;
						color: #727298;
						// margin-top: 3px;
					}
					&:hover .title{
						border-bottom:1px solid #181b49
					}
				}
			
}
:deep(.keywords-text) {
	color: #646479 !important;
}
.isAisearch{
	:deep(.w-collapse-item-header ){
     height: 34px !important;
	}
	.aisearchBox{
		height: 34px;
	}
	:deep(.w-collapse-item-active){
		background-color: var(--stages-bg) !important;
		border-radius: 8px;
		.w-collapse-item-header{
		background-color: var(--stages-bg) !important;
		// padding-top: 25px !important;
		}
	}
	:deep(.w-collapse-item-content){
		padding-top: 0px !important;
		margin-top: 0px !important;
	}
}
.mobileBox,.mobileSmartBox,.mobileProcessBox{

	:deep(.plugin){
		max-width: 90% !important;
		overflow: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
	}
}
.mobileProcessBox{
	:deep(.plugin){
		max-width: 57% !important;
	}
}
</style>
<style>
.loading-Yeicon:after{
	content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
	background-image: url('/@common/assets/chat/loading_yayi.png');
    background-position: top;
    background-size: contain;
    position: relative;
    top: 2px
}</style>
